document.addEventListener('DOMContentLoaded', function() {
    const mainNav = document.querySelector('.main-nav');
    const hamburger = document.querySelector('.hamburger');

    
    if (mainNav) {
        function handleScroll() {
            const navTop = mainNav.getBoundingClientRect().top;
            
            if (navTop <= 0) {
                mainNav.classList.add('nav-sticky');
            } else {
                mainNav.classList.remove('nav-sticky');
            }
        }
        
        window.addEventListener('scroll', handleScroll);
    }
    
    const navContainer = document.querySelector('.main-nav nav');
    
    if (hamburger && navContainer) {
        hamburger.addEventListener('click', function() {
            navContainer.classList.toggle('active');
        });
        
        // Close mobile nav when clicking outside
        document.addEventListener('click', function(e) {
            if (!navContainer.contains(e.target) && !hamburger.contains(e.target)) {
                navContainer.classList.remove('active');
            }
        });
    }
    

});